export var externalizeValue = function externalizeValue(value, timeVector) {
  return value.convertToLocalDateRange(timeVector);
};